export const DOMElementType = (props, propName, componentName) => {
  // eslint-disable-next-line no-undef
  if (props[propName] instanceof Element === false) {
    return new Error(`Invalid prop ${propName} supplied to ${componentName}. Validation failed.`)
  }

  return null
}
